import { render } from 'lighterhtml';
import haunted from 'haunted/lib/core';

const { component, createContext } = haunted({
  render(what, where) {
    // @ts-ignore
    render(where, () => what);
  },
});

export { component, createContext };
